import {useEffect, useRef, useState} from "react";
import {Slide} from "@mui/material";
import SystemModalClosingVoid from "../../others/SystemModalClosingVoid";
import Modal from "@mui/material/Modal";
import BrevetFiltersHeader from "../../headers/brevetScreen/BrevetFiltersHeader";
import BrevetFiltersContent from "../../others/brevetScreen/BrevetFiltersContent";
import { SystemQuaternaryCustomButton, SystemTertiaryCustomButton} from "../../buttons/SystemCustomButton";
import {kButtonStyles} from "../../../constants/styles";
import {toggleInArray} from "../../../helpers/ArrayHelper";

export default function BrevetFilterDialog({ open,
                                             handleClose,
                                             availableFilters,
                                             appliedFilters,
                                             applyDraftFilters }) {
    // Used in BrevetLevelAsContent to display available
    // filters for LevelAs list

    // PROPERTIES
    const modalRef = useRef();
    const [draftFilters, setDraftFilters] = useState(appliedFilters);

    // HOOKS
    // ---- At rendering
    useEffect(() => {
        if (!open) {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }
    }, [open]);
    // ---- At rendering
    useEffect(() => {
        if (open) {
            setDraftFilters(appliedFilters);
        }
    }, [open, appliedFilters]);

    // BUILD
    return (
        <Modal open={open}
               onClose={handleClose}
               disableEnforceFocus>
            <Slide direction="left" in={open} mountOnEnter unmountOnExit>
                <div ref={modalRef}
                     className="overflow-auto w-full h-[100svh] flex outline-none">
                    <SystemModalClosingVoid handleClose={handleClose} />
                    <div className={"bg-backgroundLight3 w-[416px] min-w-[416px] h-full flex flex-col justify-between"}>
                        <BrevetFiltersHeader handleClose={handleClose} />
                        <BrevetFiltersContent availableFilters={availableFilters}
                                              draftFilters={draftFilters}
                                              handleToggleGrade={handleToggleGrade}
                                              handleToggleSubtheme={handleToggleSubtheme} />
                        <div className={"w-full flex bg-gradient-to-br from-backgroundLight3 to-backgroundLight1 border-t-1 border-greyLight5 p-[16px] space-x-[12px]"}>
                            <SystemQuaternaryCustomButton
                                label={"Annuler"}
                                isDisabled={false}
                                isLoading={false}
                                isFullWidth={false}
                                sizeStyle={kButtonStyles.mediumButtonStyle}
                                onButtonClick={handleClose} />
                            <SystemTertiaryCustomButton
                                label={"Valider"}
                                isDisabled={isFiltersEmpty()}
                                isLoading={false}
                                isFullWidth={true}
                                sizeStyle={kButtonStyles.mediumButtonStyle}
                                onButtonClick={() => applyDraftFilters(draftFilters)} />
                        </div>
                    </div>
                </div>
            </Slide>
        </Modal>
    );

    // METHODS
    // ---- LOGIC : Handle toggle subtheme
    function handleToggleSubtheme(subtheme) {
        setDraftFilters(prev => ({
            ...prev,
            subthemes: toggleInArray(prev.subthemes, subtheme),
        }));
    }

    // ---- LOGIC : Handle toggle grade
    function handleToggleGrade(grade) {
        setDraftFilters(prev => ({
            ...prev,
            grades: toggleInArray(prev.grades, grade),
        }));
    }

    // ---- LOGIC : isFiltersEmpty
    function isFiltersEmpty() {
        if (!draftFilters) return true
        const subthemesCount = Array.isArray(draftFilters.subthemes) ? draftFilters.subthemes.length : 0;
        const gradesCount = Array.isArray(draftFilters.grades) ? draftFilters.grades.length : 0;
        const mediaCount = Array.isArray(draftFilters.media) ? draftFilters.media.length : 0;
        const sum = subthemesCount + gradesCount + mediaCount
        return sum <= 0
    }
}